import { useCallback } from "react";

// NOTE: This is configured such that these inputs should not be blank and
// should have a value - even if it is a 0 for number inputs.

const REQUIRED_FIELDS = [
  {
    enabler: "sass_fee",
    value: "sass_fee_default",
  },
  {
    enabler: "purchase_for",
    value: "purchase_for_default",
  },
  {
    enabler: "lease_for",
    value: "lease_for_default",
  },
  {
    enabler: "rent_for",
    value: "rent_for_default",
  },
  {
    enabler: "monthly_fee",
    value: "monthly_fee_default",
  },
  {
    enabler: "per_transaction",
    value: "per_transaction_default",
  },
  {
    enabler: "factor_rate",
    value: "factor_rate_default",
  },
  {
    enabler: "payback",
    value: "payback_default",
  },
  {
    enabler: "monthly_wireless",
    value: "monthly_wireless_default",
  },
  {
    enabler: "text_sms_fee",
    value: "text_sms_fee_default",
  },
  {
    enabler: "sim_card_monthly",
    value: "sim_card_monthly_default",
  },
  {
    enabler: "monthly_cellular_txn",
    value: "monthly_cellular_txn_default",
  },
  {
    enabler: "cellular_per_txn",
    value: "cellular_per_txn_default",
  },
  {
    enabler: "pin_pad",
    value: "pin_pad_name_default",
  },
];

const useEquipmentValidation = () => {
  const validateField = useCallback((equipment, field) => {
    if (field in equipment) {
      const value = equipment[field];
      return (
        value === null || value === undefined || String(value).trim() === ""
      );
    }
    return false;
  }, []);

  const validateEquipment = useCallback(
    (equipment) => {
      const errorFields = new Set();

      REQUIRED_FIELDS.forEach((field) => {
        if (
          field.enabler in equipment &&
          equipment[field.enabler] === 1 &&
          validateField(equipment, field.value)
        ) {
          errorFields.add(field.value);
        }
      });

      return {
        hasErrors: errorFields.size > 0,
        errorFields,
      };
    },
    [validateField],
  );

  return {
    validateEquipment,
    validateField,
  };
};

export default useEquipmentValidation;
